import React from 'react';
import PropTypes from 'prop-types';

export default function ActsIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill={color} {...rest}>
      <path d="M0 0.399902H19.9782V2.51316H0V0.399902Z" fill="#00001B" />
      <path d="M4.2927 6.07573V8.9298H7.14675V6.07573H4.2927Z" fill="#00001B" />
      <path
        d="M4.2927 13.2102V10.3561H7.14675V13.2102H4.2927Z"
        fill="#00001B"
      />
      <path
        d="M8.56192 6.07573V8.9298H11.416V6.07573H8.56192Z"
        fill="#00001B"
      />
      <path
        d="M8.56192 13.2102V10.3561H11.416V13.2102H8.56192Z"
        fill="#00001B"
      />
      <path
        d="M8.56192 14.6247V17.4788H11.416V14.6247H8.56192Z"
        fill="#00001B"
      />
      <path
        d="M4.2927 17.4788V14.6247H7.14675V17.4788H4.2927Z"
        fill="#00001B"
      />
      <path
        d="M12.8311 6.07573V8.9298H15.6852V6.07573H12.8311Z"
        fill="#00001B"
      />
      <path
        d="M12.8311 13.2102V10.3561H15.6852V13.2102H12.8311Z"
        fill="#00001B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9761 3.2274V13.2225L20 17.1046L17.973 19.0388C17.5734 19.4201 17.0491 19.6302 16.4967 19.6302H3.53281C2.9805 19.6302 2.45617 19.4201 2.05662 19.0388L0.0333246 17.1082L0.00938978 13.2269V3.2274L9.99267 3.23373L19.9761 3.2274ZM16.4967 18.2073C16.6816 18.2073 16.857 18.137 16.9907 18.0094L18.5733 16.4992L18.5532 13.2269V4.65121L9.99267 4.65663L1.43229 4.65121V13.2225L1.4524 16.4956L3.03891 18.0094C3.17262 18.137 3.34804 18.2073 3.53281 18.2073H16.4967Z"
        fill="#00001B"
      />
    </svg>
  );
}

ActsIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

ActsIcon.defaultProps = {
  size: 20,
  color: '#000',
};
